import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Loader from '../../../../components/Loader';
import { useAgreements } from '../../../../hooks/api/useAgreements';
import { Agreements } from '../../../../types/Agreements.types';
import { AgreementForm } from './AgreementForm';

function AgreementFormView() {
  const { fetchAgreementById } = useAgreements();
  const { agreementId } = useParams<{ agreementId: string }>();
  const [agreement, setAgreement] = useState<Agreements>();

  useEffect(() => {
    setAgreement(undefined);
    const fetchAgreement = async () => {
      if (agreementId) {
        const agreement = await fetchAgreementById(agreementId);
        if (agreement) {
          setAgreement(agreement);
        }
      }
    };
    fetchAgreement();
  }, [fetchAgreementById, agreementId]);

  if (!agreement && agreementId) return <Loader />;

  return <AgreementForm agreement={agreement} />;
}

export default AgreementFormView;
